import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {CrystalClearFrontUrl} from "../../../../shared/pages/crystal-clear-front-url";
import {ClearingAllocationTaskService} from "../../../../services/clearing/clearing-allocation-task.service";

@Component({
  selector: 'app-allocation-tasks-button',
  templateUrl: './allocation-tasks-button.component.html',
  styleUrls: ['./allocation-tasks-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllocationTasksButtonComponent extends CcBaseComponent {

  @Input()
  buttonTitle: string = 'page.clearing.task.title';
  @Input()
  transPartKey: string = 'clearing.task';
  CrystalClearFrontUrl = CrystalClearFrontUrl;

  inProgressCount: number = 0;

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected allocationTaskService: ClearingAllocationTaskService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

  }

}
